var render = function render(){var _vm=this,_c=_vm._self._c;return _c('grid-item',{attrs:{"legend":"Situação dos Cadastros","icon":"check","icon-type":"fa","ch-legend":"GRÁFICO DOS CADASTROS DE ACORDO O STATUS","link":() => _vm.$router.push({name: 'arrematantes.habilitacao'})},scopedSlots:_vm._u([{key:"card-footer",fn:function(){return undefined},proxy:true}])},[[_c('aprovacao')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }